/** Filtro de rango de fechas (día desde / hasta, zona Caracas) con atajo "Hoy". Pedido del cliente 03-10-2026 para documentos, entregas y devoluciones. */
import { Button } from '@/componentes/ui/button.tsx';
import { Input } from '@/componentes/ui/input.tsx';

/** Fecha de hoy en Caracas como YYYY-MM-DD (lo que esperan los filtros `desde`/`hasta` de la API). */
export function hoyCaracas(): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Caracas' }).format(new Date());
}

export function FiltroFechas({ desde, hasta, onChange, testid }: { desde: string; hasta: string; onChange: (desde: string, hasta: string) => void; testid: string }) {
  const hoy = hoyCaracas();
  return (
    <div className="flex items-center gap-1" data-testid={`${testid}-fechas`}>
      <Input type="date" value={desde} max={hasta || undefined} onChange={(e) => onChange(e.target.value, hasta)} className="w-36" aria-label="Desde" data-testid={`${testid}-desde`} />
      <span className="text-xs text-muted-foreground">a</span>
      <Input type="date" value={hasta} min={desde || undefined} onChange={(e) => onChange(desde, e.target.value)} className="w-36" aria-label="Hasta" data-testid={`${testid}-hasta`} />
      <Button type="button" size="sm" variant={desde === hoy && hasta === hoy ? 'default' : 'outline'} onClick={() => onChange(hoy, hoy)} data-testid={`${testid}-hoy`}>
        Hoy
      </Button>
      {desde || hasta ? (
        <Button type="button" size="sm" variant="ghost" onClick={() => onChange('', '')} aria-label="Quitar fechas">
          ×
        </Button>
      ) : null}
    </div>
  );
}
